/**
 * @description Highlight Services: Insert Placeholder
 */

/* global ModuloTS bsBreakpoints */

(() => {
	// VARIABLES
	const root = document.querySelector('.highlight__services');
	const bsBreakpoint = bsBreakpoints.detectBreakpoint();

	// HELPER

	/**
	 * @description Helper : set multiples attributes to one element
	 */
	function setAttributes(el, attrs) {
		for (const key in attrs) {
			el.setAttribute(key, attrs[key]);
		}
	}

	// FONCTIONS
	const insertPlaceholder = () => {
		if (root) {
			const el = root
				.querySelector('.form__field')
				.querySelector("[type='text']");
			const txt = ModuloTS['What are you looking for ?'];

			setAttributes(el, {
				placeholder: txt,
				title: txt,
			});
		}
	};

	const imgMobileServices = () => {
		const highlight = document.querySelector('[data-img-mobile]') || null;

		if (bsBreakpoint === 'xSmall' && highlight) {
			highlight.style.backgroundImage = `url(${highlight.getAttribute(
				'data-img-mobile'
			)})`;
		}
	};

	// GO 🚀
	const init = () => {
		insertPlaceholder();
		imgMobileServices();
	};

	init();
})();
